export default "__VITE_ASSET__60cea6a4__"